import React, { useEffect, useState } from "react";
import UseInView from "../../components/Generic/UseInView";

const CohortPillar = () => {
  const parts = [
    "/assets/images/Cohort/1.svg?ver=1",
    "/assets/images/Cohort/2.svg?ver=1",
    "/assets/images/Cohort/3.svg?ver=1",
    "/assets/images/Cohort/4.svg?ver=1",
    "/assets/images/Cohort/5.svg?ver=1",
    "/assets/images/Cohort/6.svg?ver=1",
    "/assets/images/Cohort/7.svg?ver=1",
    "/assets/images/Cohort/8.svg?ver=1",
    "/assets/images/Cohort/9.svg?ver=1",
    "/assets/images/Cohort/10.svg?ver=1",
    "/assets/images/Cohort/11.svg?ver=1",
    "/assets/images/Cohort/12.svg?ver=1",
    "/assets/images/Cohort/13.svg?ver=1",
    "/assets/images/Cohort/14.svg?ver=1",
    "/assets/images/Cohort/15.svg?ver=1",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  //allow pause/resume
  const [containerRef, inView] = UseInView({ threshold: 0.3 }, false);

  // Preload all images once
  useEffect(() => {
    let loaded = 0;
    parts.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loaded++;
        if (loaded === parts.length) setImagesLoaded(true);
      };
    });
  }, []);

  // Handle animation — starts and pauses based on visibility
  useEffect(() => {
    if (!imagesLoaded) return;

    let interval = null;
    if (inView) {
      interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % parts.length);
      }, 500);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [inView, imagesLoaded, parts.length]);

  return (
    <div ref={containerRef} className="cohort-filler-container">
      {imagesLoaded ? (
        <img
          src={parts[currentIndex]}
          alt={`Cohort part ${currentIndex + 1}`}
          className="cohort-filler-piece"
        />
      ) : (
        <div className="cohort-placeholder">Loading...</div>
      )}
    </div>
  );
};

export default CohortPillar;
